export const SET_IMAGE = "IMAGE_SET_IMAGE"  
export const SET_NAME = "IMAGE_SET_NAME" 
export const SET_FORMAT = "IMAGE_SET_FORMAT" 
export const SET_DIMENSION = "IMAGE_SET_DIMENSION" 
export const SET_PROPORTIONS = "IMAGE_SET_PROPORTIONS"